import { render, staticRenderFns } from "./AgroTabComponent.vue?vue&type=template&id=7ab0d0c0&scoped=true"
import script from "./AgroTabComponent.js?vue&type=script&lang=js&external"
export * from "./AgroTabComponent.js?vue&type=script&lang=js&external"
import style0 from "./AgroTabComponent.vue?vue&type=style&index=0&id=7ab0d0c0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ab0d0c0",
  null
  
)

export default component.exports